import type { SocialMatchRequestReason } from "@/entities/social-match"

// Повод познакомиться — три вида, у каждого свой текст. Заполнять можно все
// сразу, поэтому храним текст по виду, а что именно уйдёт на бэк, решает
// collectSocialMatchRequestReasons.
export const SOCIAL_MATCH_REQUEST_REASON_KINDS = [
	"shared_activity",
	"learning_goal",
	"offered_expertise",
] as const

// Лимит и для основного запроса, и для каждого повода — как у `expertise`
// в профиле.
export const SOCIAL_MATCH_REQUEST_TEXT_MAX_LENGTH = 500

export type SocialMatchRequestReasonKind =
	(typeof SOCIAL_MATCH_REQUEST_REASON_KINDS)[number]

export type SocialMatchRequestReasonTexts = Record<
	SocialMatchRequestReasonKind,
	string
>

export const DEFAULT_SOCIAL_MATCH_REQUEST_REASON_KIND: SocialMatchRequestReasonKind =
	"learning_goal"

export const EMPTY_SOCIAL_MATCH_REQUEST_REASON_TEXTS: SocialMatchRequestReasonTexts =
	{
		shared_activity: "",
		learning_goal: "",
		offered_expertise: "",
	}

// Поле `reason` запроса: только заполненные поводы без пробелов по краям,
// null — если не заполнен ни один. Ключи SocialMatchRequestReasonKind обязаны совпадать
// с ключами SocialMatchRequestReason — иначе тут упадёт typecheck.
export function collectSocialMatchRequestReasons(
	requestReasons: SocialMatchRequestReasonTexts,
): SocialMatchRequestReason | null {
	const filled: SocialMatchRequestReason = {}
	for (const kind of SOCIAL_MATCH_REQUEST_REASON_KINDS) {
		const value = requestReasons[kind].trim()
		if (value) filled[kind] = value
	}
	if (Object.keys(filled).length === 0) return null
	return filled
}
